import type { SVGProps } from 'react'
const SvgSyMic = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillOpacity={0.24}
				d="M12 3c1.662 0 3 1.338 3 3v5c0 1.662-1.338 3-3 3s-3-1.338-3-3V6c0-1.662 1.338-3 3-3"
			/>
			<path d="M12 2.4A3.605 3.605 0 0 0 8.4 6v5c0 1.984 1.616 3.6 3.6 3.6s3.6-1.616 3.6-3.6V6c0-1.984-1.616-3.6-3.6-3.6m0 1.2c1.34 0 2.4 1.06 2.4 2.4v5c0 1.34-1.06 2.4-2.4 2.4S9.6 12.34 9.6 11V6c0-1.34 1.06-2.4 2.4-2.4" />
			<path d="M5.4 10.4a.6.6 0 0 0-.6.6 7.2 7.2 0 0 0 2.108 5.092A7.201 7.201 0 0 0 19.2 11a.6.6 0 0 0-.6-.6.6.6 0 0 0-.599.6 5.999 5.999 0 0 1-12 0 .6.6 0 0 0-.6-.6" />
			<path d="M12 18.4a.6.6 0 0 0-.6.6v2a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6v-2a.6.6 0 0 0-.6-.6" />
		</g>
	</svg>
)
export default SvgSyMic
